import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fo_user")); } catch { return null; }
  });
  const [familyOffice, setFamilyOffice] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fo_office")); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const persist = (sessionToken, u, fo) => {
    localStorage.setItem("fo_session", sessionToken);
    localStorage.setItem("fo_user", JSON.stringify(u));
    if (fo) localStorage.setItem("fo_office", JSON.stringify(fo));
    setUser(u);
    if (fo) setFamilyOffice(fo);
  };

  const login = useCallback(async (tokenText) => {
    const { data } = await api.post("/auth/login", { token: tokenText });
    persist(data.session_token, data.user, data.family_office);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("fo_session");
    localStorage.removeItem("fo_user");
    localStorage.removeItem("fo_office");
    setUser(null);
    setFamilyOffice(null);
    window.location.href = "/login";
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("fo_session");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data.user); setFamilyOffice(data.family_office); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, familyOffice, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
